<footer class="footer" role="contentinfo" data-track-group="Footer">
  <div class="footer__user">
    <div [class]="mainContainerClass">
      <div [class]="pageContainerClass">
        <ftr-footer-logged-out />
      </div>
    </div>
  </div>
  <div class="footer__disclaimer">
    <div [class]="mainContainerClass">
      <div [class]="pageContainerClass">
        <ftr-footer-disclaimer />
      </div>
    </div>
  </div>
</footer>
